import styled from "styled-components";
import { ClipboardText } from "@phosphor-icons/react";
import tokens from "../../theme/tokens";

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 140px);
  padding: 48px 24px;
  font-family: ${tokens.typography.fontFamily};
  color: ${tokens.text.primary};
`;

const IconBadge = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 16px;
  background: ${tokens.status.review.bg};
  border: 1px solid ${tokens.status.review.border};
  color: ${tokens.status.review.fg};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: ${tokens.typography.weight.semibold};
  color: ${tokens.text.primary};
`;

const Subtitle = styled.p`
  margin: 0 0 24px;
  max-width: 520px;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
  color: ${tokens.text.secondary};
`;

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 9999px;
  background: ${tokens.brand.primaryLight};
  color: ${tokens.brand.primary};
  font-size: 12px;
  font-weight: ${tokens.typography.weight.semibold};
`;

/**
 * Placeholder Review Queue page.
 *
 * Reached via the "Needs Review" status chip on matter details rows.
 * Full implementation (list of low-confidence documents across matters,
 * bulk re-categorize, assign reviewer) is tracked separately.
 */
const Review = () => {
  return (
    <Page>
      <IconBadge>
        <ClipboardText size={36} weight="duotone" />
      </IconBadge>
      <Title>Review queue</Title>
      <Subtitle>
        This is where documents the AI flagged for human review will collect.
        You&apos;ll be able to re-categorize, approve, or reassign in bulk.
        Coming soon.
      </Subtitle>
      <Pill>In design</Pill>
    </Page>
  );
};

export default Review;
